import { Type } from "lucide-react";
import type React from "react";
import type { DataFieldTextarea } from "schema/agent";
import { Field } from "./Field";

export interface TextareaFieldProps {
  field: DataFieldTextarea;
  onChange: (value: string) => void;
}

export const TextareaField: React.FC<TextareaFieldProps> = ({ field, onChange }) => {
  return (
    <Field icon={Type} label={field.label} visibleAt={field.visibleAt}>
      <textarea
        value={field.value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={field.placeholder}
        rows={field.rows ?? 2}
        className="w-full bg-slate-900/50 text-slate-300 text-xs px-2 py-1 rounded focus:outline-none focus:ring-1 focus:ring-indigo-500 resize-none"
      />
    </Field>
  );
};
